import React from 'react';
import { Tabs } from 'antd';
import {
  UserOutlined, DollarOutlined, WarningOutlined,
  TeamOutlined, BookOutlined, BarChartOutlined, ClockCircleOutlined,
  TrophyOutlined, HistoryOutlined, BankOutlined, AppstoreOutlined,
  EyeInvisibleOutlined,
} from '@ant-design/icons';
import useAuthStore from '../store/authStore';
import AttendanceReportTab  from '../components/reports/AttendanceReportTab';
import FinanceReportTab     from '../components/reports/FinanceReportTab';
import DebtReportTab        from '../components/reports/DebtReportTab';
import ManualDebtsReportTab from '../components/reports/ManualDebtsReportTab';
import TeachersReportTab    from '../components/reports/TeachersReportTab';
import CoursesReportTab     from '../components/reports/CoursesReportTab';
import MonthlyTrendTab      from '../components/reports/MonthlyTrendTab';
import AbsenceReportTab     from '../components/reports/AbsenceReportTab';
import MissingProjectsReportTab from '../components/reports/MissingProjectsReportTab';
import HiddenProgressReportTab from '../components/reports/HiddenProgressReportTab';
import RoutinesReportTab    from '../components/reports/RoutinesReportTab';
import CompetitionsReportTab from '../components/reports/CompetitionsReportTab';
import SchoolsReportTab     from '../components/reports/SchoolsReportTab';
import ClassroomLoadReportTab from '../components/reports/ClassroomLoadReportTab';
import ReenrollmentReportTab from '../components/reports/ReenrollmentReportTab';

const { TabPane } = Tabs;

const Reports = () => {
  const { user } = useAuthStore();
  // Yarışma raporu competitions.view iznine bağlı; bu izin varsayılan olarak
  // yalnızca süper admin+ rollerinde. Raporlar sayfasının kendisi şube
  // müdürüne de açık olduğu için sekmeyi role göre gizliyoruz — aksi halde
  // sekmeye basan şube müdürü 403 alırdı. (Asıl kısıt backend'de.)
  const canSeeCompetitions = ['developer_admin', 'super_admin'].includes(user?.role);

  return (
  <div>
    <h2 className="text-2xl font-bold mb-6">Raporlar</h2>
    {/* Açılış sekmesi Derslik Doluluk — yeni öğrenci yerleştirirken ilk
        bakılan yer (kullanıcının isteği, 2026-08-14). */}
    <Tabs defaultActiveKey="classroom-load">
      {/* Yeni öğrenci yerleştirirken ilk bakılan yer olduğu için ilk sekme. */}
      <TabPane tab={<span><AppstoreOutlined /> Derslik Doluluk</span>} key="classroom-load">
        <ClassroomLoadReportTab />
      </TabPane>
      {/* Dönem sonunda "kim gitti" listesi — Derslik Doluluk'un hemen
          yanında, çünkü ikisi birlikte kullanılıyor: kim ayrıldı, boşalan
          yere kimi koyabilirim. */}
      <TabPane tab={<span><TeamOutlined /> Dönem Geçişi</span>} key="reenrollment">
        <ReenrollmentReportTab />
      </TabPane>
      <TabPane tab={<span><UserOutlined /> Devam</span>}            key="attendance">
        <AttendanceReportTab />
      </TabPane>
      <TabPane tab={<span><DollarOutlined /> Finansal</span>}       key="finance">
        <FinanceReportTab />
      </TabPane>
      <TabPane tab={<span><WarningOutlined /> Borç / Alacak</span>} key="debt">
        <DebtReportTab />
      </TabPane>
      <TabPane tab={<span><HistoryOutlined /> Geçmiş Dönem Borçları</span>} key="manual-debts">
        <ManualDebtsReportTab />
      </TabPane>
      <TabPane tab={<span><TeamOutlined /> Öğretmenler</span>}      key="teachers">
        <TeachersReportTab />
      </TabPane>
      <TabPane tab={<span><BankOutlined /> Okullar</span>}          key="schools">
        <SchoolsReportTab />
      </TabPane>
      <TabPane tab={<span><BookOutlined /> Kurs Tamamlanma</span>}  key="courses">
        <CoursesReportTab />
      </TabPane>
      <TabPane tab={<span><BarChartOutlined /> Aylık Trend</span>}  key="trend">
        <MonthlyTrendTab />
      </TabPane>
      <TabPane tab={<span><WarningOutlined /> Günlük Devamsızlık</span>} key="absences">
        <AbsenceReportTab />
      </TabPane>
      <TabPane tab={<span><WarningOutlined /> Projesi Girilmemiş Dersler</span>} key="missing-projects">
        <MissingProjectsReportTab />
      </TabPane>
      <TabPane tab={<span><EyeInvisibleOutlined /> İlerleyişi Gizlenenler</span>} key="hidden-progress">
        <HiddenProgressReportTab />
      </TabPane>
      <TabPane tab={<span><ClockCircleOutlined /> Rutinler</span>} key="routines">
        <RoutinesReportTab />
      </TabPane>
      {canSeeCompetitions && (
        <TabPane tab={<span><TrophyOutlined /> Yarışma</span>} key="competitions">
          <CompetitionsReportTab />
        </TabPane>
      )}
    </Tabs>
  </div>
  );
};

export default Reports;
